const Marquee = ({ items, dark = true }) => {
  const row = [...items, ...items];
  return (
    <div
      className={`overflow-hidden border-y py-4 ${dark ? "border-white/10 bg-[#070A10]" : "border-slate-200 bg-slate-50"}`}
      data-testid="marquee-strip"
    >
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className={`font-mono text-xs font-medium uppercase tracking-[0.3em] ${dark ? "text-slate-500" : "text-slate-400"}`}>
              {item}
            </span>
            <span className={dark ? "text-cyan-400/60" : "text-red-500/60"}>✚</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
